/**
 * Which pinned Analytics boards take a slot on the home page's "My Widgets"
 * panel.
 *
 * A player can pin as many boards as they like, but the panel only has three
 * slots and boards shouldn't crowd out the rest, so at most two are drawn.
 * Each pin carries `showOnHome`; a pin with no flag (made before the cap
 * existed) counts as on, and only an explicit false opts out. The same rule
 * runs on the server when a new pin is created, so the two never disagree.
 */
export const HOME_DASHBOARD_LIMIT = 2;

export const isOnHome = (pin) => pin?.showOnHome !== false;

/** The pins that get a home slot, in the order they were pinned. */
export const pickHomeDashboards = (pins) =>
  (pins || []).filter(isOnHome).slice(0, HOME_DASHBOARD_LIMIT);

export const HOME_PANEL_SLOTS = 3;

/**
 * The real widgets that fit in the panel's three slots.
 *
 * Dashboards are placed first (they're already capped at two), and the other
 * widgets fill what's left. Taking the first three in saved order instead
 * would let a player's older widgets squeeze a chosen dashboard out. The
 * result keeps the original order, so cards don't shuffle.
 *
 * `widgets` is expected to be already filtered to the dashboards that are
 * readable and on the home page.
 */
export const fitHomePanel = (widgets, slots = HOME_PANEL_SLOTS) => {
  const list = widgets || [];
  const isBoard = (w) => w.key === "dashboard_link";
  const boards = list.filter(isBoard).slice(0, HOME_DASHBOARD_LIMIT);
  const others = list.filter((w) => !isBoard(w)).slice(0, Math.max(0, slots - boards.length));
  const keep = new Set([...boards, ...others]);
  return list.filter((w) => keep.has(w));
};
